import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryCounts_ds_get_inventory_counts_by_warehouseIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseIds?: number[], statusIds?: number[] }): 
  Promise<{ result: { Id?: number, StatusId?: number, InventoryCountTaskProperties?: { BatchCreationTime?: string, Task?: { Id?: number, ActualPackagedAmount?: number, ChainHead?: number, ExpectedPackagedAmount?: number, OperationCodeId?: number, StatusId?: number } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_counts_by_warehouseIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { warehouseIds?: number[], statusIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, StatusId?: number, InventoryCountTaskProperties?: { BatchCreationTime?: string, Task?: { Id?: number, ActualPackagedAmount?: number, ChainHead?: number, ExpectedPackagedAmount?: number, OperationCodeId?: number, StatusId?: number } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_counts_by_warehouseIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { warehouseIds?: number[], statusIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, StatusId?: number, InventoryCountTaskProperties?: { BatchCreationTime?: string, Task?: { Id?: number, ActualPackagedAmount?: number, ChainHead?: number, ExpectedPackagedAmount?: number, OperationCodeId?: number, StatusId?: number } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryCounts/datasources/ds_get_inventory_counts_by_warehouseIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseIds?: number[], statusIds?: number[]    }) {
      return false;
    }
}
